<template>
  <div class="home-header">
      <div class="header-left">
        <div class="header-logo-img">
          <img class="logo-img" :src="store.state.images.logo">
        </div>
          <div class="header-title-box">
            <h2 class="header-title">航旅达人</h2>
          <span class="header-English">Hang Lv Da Ren</span>
          </div>
      </div>
      <div class="header-right">
        <span class="header-jump-item">公司简介</span>
        <span class="header-jump-item">加入我们</span>
        <span class="header-jump-item">联系我们</span>
      </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'

const store = useStore()

</script>

<style scoped>
.home-header {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 100px 0 20px;
  background-color: rgb(63, 84, 245);
}

.header-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}

.header-logo-img {
  width: 50px;
  height: 50px;
}

.logo-img {
  width: 100%;
  height: 100%;
}

.header-title-box {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  margin-left: 4px;
  align-items: flex-start;
}

.header-title {
  font-weight: 400;
  color: #fff;
}

.header-English {
  color: #fff;
}

.header-jump-item {
  color: #fff;
  margin-right: 16px;
  padding: 4px 10px;
  border-radius: 30px;
}

.header-jump-item:hover {
  color: rgb(63, 84, 245);
  background-color: #fff;
  cursor: pointer;
}
</style>